import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from '../../icon/';

import './style.scss';

const Dismiss = ({ size, className, qaId, hudlElement, onClick }) => {
  const dismissClasses = classNames('uni-dismiss', className);

  return (
    <button className={dismissClasses} data-qa-id={qaId} data-hudl-element={hudlElement} onClick={onClick}>
      <Icon size={size} type="uidismiss" />
    </button>
  );
};

Dismiss.propTypes = {
  size: PropTypes.oneOf(['small', 'medium', 'large']).isRequired,
  className: PropTypes.string,
  qaId: PropTypes.string,
  hudlElement: PropTypes.string,
  onClick: PropTypes.func,
};

export default Dismiss;



// WEBPACK FOOTER //
// ./src/__partials/dismiss/index.jsx